import { gql } from "@apollo/client"

export const TRIP_ORDERS_FRAG = gql`
  fragment TripOrdersFrag on TripType {
    id
    status
    labourCount
    DEPOrganisationUser {
      id
      fullName
    }
    date
    vehicle {
      id
      registrationNumber
      vehicleType {
        id
        name
        capacity
        capacityUnit {
          id
          codename
        }
      }
      driver {
        id
        fullName
        number
      }
    }
    sourceDepot {
      id
      name
      location {
        id
        latitude
        longitude
      }
    }
    estimatedStartTime
    destinationDepot {
      id
      name
      location {
        id
        latitude
        longitude
      }
    }
    transportDetail {
      id
      advanceCost
      transportCost
    }
    aggregator {
      id
      fullName
    }

    bookings {
      id
      requiredQuantity
      order {
        id
        orderStatus
        totalWeight
        shippingCharges
        discount {
          id
          flat
          percentage
        }
        metadata
        user {
          id
          fullName
        }
        crateCount
        shippingAddress {
          id
          latitude
          longitude
          village
          district
          address
        }
        orderItems {
          id
          quantity
          rate
          sellableItem {
            id
            name
          }
        }
      }
      orderItem {
        id
        quantity
        rate
        metadata
        discount {
          id
          flat
          percentage
        }
        actualRate
        bookedQuantity
        sellableItem {
          id
          name
          taxes {
            id
            name
            percentage
          }
        }
      }
      schedule {
        id
      }
    }
    loadingPattern
    estimatedDespatchTime
  }
`
